<script setup>
import { onMounted, ref } from 'vue'
import { api } from '@/lib/http.js'

/** Published offer templates (online: templates are not part of the replica). */
defineProps({ modelValue: { type: String, default: null } })
const emit = defineEmits(['update:modelValue'])
const templates = ref([])
const failed = ref(false)
onMounted(async () => {
  try {
    templates.value = (await api('/catalog/templates')).data.filter((t) => t.is_active && t.current)
    if (templates.value.length === 1) emit('update:modelValue', templates.value[0].uuid)
  } catch {
    failed.value = true
  }
})
</script>

<template>
  <select class="input" :value="modelValue || ''" @change="emit('update:modelValue', $event.target.value || null)">
    <option value="">{{ failed ? $t('messages.onlineOnly') : templates.length ? $t('common.select') : $t('offers.noTemplates') }}</option>
    <option v-for="t in templates" :key="t.uuid" :value="t.uuid">{{ t.name }}</option>
  </select>
</template>
